import colors from './colors';

import type { DefaultTheme } from 'styled-components';

const theme: DefaultTheme = {
  fonts: {
    text: 'Inter, Helvetica, Arial, sans-serif',
    header: 'Inter, Helvetica, Arial, sans-serif',
  },
  colors,
};

export default theme;
